angular.module('app.notes', [
  'pascalprecht.translate',
  'angularFileUpload',
  'angular.filter',
  'ngSlider',
  'ngCookies',
  'ngAnimate',
  'ngSanitize',
  'angularSpinner',
  'angular-clipboard',
  'ui.nested.combobox',
])

require('./notes-modal')
require('./notes.ctrl')
require('./notes.directive')
require('./notes.api')
require('./notes-modal.ctrl')



// WEBPACK FOOTER //
// ./scripts/notes/module.js